module.exports = {
  PORT: "4025",
  NODE_ENV: "production",

  SERVER_DEV_URL: "http://localhost:3123",
  SERVER_STAGING_URL: "https://smartscoregolf-api.cloudxier.dev",
  SERVER_PROD_URL: "https://smartscoregolf-api.cloudxier.com",

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: "smartscoregolf.cloudxier.dev",
  CLIENT_PROD_HOST: "digitalcup.bigeventasia.id",

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: "https://smartscoregolf.cloudxier.dev",
  CLIENT_PROD_URL: "https://digitalcup.bigeventasia.id",

  MAIN_WEBSITE_TITLE: 'SMARTSCORE | ',
  SITE_NAME: 'SMARTSCORE Digital Cup Version 2.0'
}
